import React, {Component} from "react";


import "../../node_modules/swagger-ui/dist/swagger-ui.css"
import SwaggerUI from 'swagger-ui';

import "./SwaggerUIPage.css";

import Sidebar from "../components/Sidebar";
import { RedocStandalone } from "redoc";
import logo from  "../components/Myntra_logo.png";


const getOpenApiJsonContentUrl = "/getOpenApiJsonContent/openApiJsonLink/";
const getPostmanCollectionContentUrl="/getPostmanCollectionContent/postmanCollectionLink/";


class SwaggerUIPagePublic extends Component {
    state = {
        serviceEndpointListing: [],
        organizationName: "Myntra",
        openApiJsonLink: "",
        postmanCollectionLink: "",
        clientId: 1,
        showModal: false,
        versionData: [],
        openApiJsonName: "",
        postmanCollectionName: "",
        createdBy: "",
        lastModifiedOn: ""
    };

    componentDidMount() {
        this.getServiceEndpointListing()
          .then(res => {
            this.setState({serviceEndpointListing: res});
            if (this.state.serviceEndpointListing != null && this.state.serviceEndpointListing.length > 0) {
                this.setState({
                    openApiJsonLink: getOpenApiJsonContentUrl + this.state.serviceEndpointListing[0].openapi_json,
                    postmanCollectionLink: getPostmanCollectionContentUrl+this.state.serviceEndpointListing[0].postman_collectionv2,
                    clientId: this.state.serviceEndpointListing[0].id,
                    openApiJsonName: this.state.serviceEndpointListing[0].openapi_json,
                    postmanCollectionName: this.state.serviceEndpointListing[0].postman_collectionv2,
                    createdBy: this.state.serviceEndpointListing[0].created_by,
                    lastModifiedOn: this.state.serviceEndpointListing[0].last_modified_on
                });
            }
          })
        .catch(err => {});
    }

    
    DisableTryItOutPlugin = function() {
        return {
          statePlugins: {
            spec: {
              wrapSelectors: {
                allowTryItOutFor: () => () => false
              }
            }
          }
        }
    }


    getServiceEndpointListing = async () => {
        const response = await fetch('/getServiceEndpointListingExternal');
        const body = await response.json();
        if (response.status !== 200) throw Error(body.message);
        return body;
    }

    updateStateForNewSelectedClient = async (newOpenApiLink,newPostmanv2Link,newClientId,newOpenApiName,newPostmanCollectionName,newCreatedBy,newLastModifiedOn) => {
        this.setState({
            openApiJsonLink: getOpenApiJsonContentUrl + newOpenApiLink,
            postmanCollectionLink: getPostmanCollectionContentUrl + newPostmanv2Link,
            clientId: newClientId,
            openApiJsonName: newOpenApiName,
            postmanCollectionName: newPostmanCollectionName,
            createdBy: newCreatedBy,
            lastModifiedOn: newLastModifiedOn
        });
    }

    updateModalStatesPP = async(showVal) => {
        this.setState({
            showPrivacyModal: showVal,
        });
    }

    render() {
        return (
            <div className="SwaggerUIPage">
            <div className="SwaggerUIPageHeader">
                <img src={logo} alt="Myntra Logo"/>
                 <div id="header-text">
                    <h1>Developer API</h1>
                </div>
                </div>
                <div className="SwaggerUIPageBody">
                
                    <Sidebar
                        organizationName={this.state.organizationName}
                        definitionList={this.state.serviceEndpointListing}
                        updateDefinitionLink={this.updateStateForNewSelectedClient}
                        getOrganizationData={this.getOrganizationData}
                    />
                    <div>
                    <div id="api-data">
                    <RedocStandalone specUrl= {this.state.openApiJsonLink}
                            options={{
                            hideDownloadButton: true,
                            disableSearch: true,
                            theme: { 
                            sidebar: { width: "0px" }, 
                            colors: { primary: { main: '#5047C8' }}, 
                            rightPanel: {backgroundColor: "#302A8D", textColor: "#E5E2F5"}
                            }
                            }}
                        />
                        </div>
                    </div> 
                </div>

                 {/* <PrivacyPolicy
                show={this.state.showPrivacyModal}
                updateModalStatesPP={this.updateModalStatesPP}
                /> */}
            </div>
        )
    }
}

export default SwaggerUIPagePublic;